import { message } from 'antd';
import { rejectDocumentEditRequests } from '../../../../services/popupApi';

export const api = {
  submit: async (values, context) => {
    const ids = context.selectedIds ?? [];
    const result = await rejectDocumentEditRequests({
      ids,
      rejectionReason: String(values.rejectionReason ?? '').trim(),
    });

    // The gateway answers 200 even when no request was eligible — already
    // decided, the reviewer's own request, or outside their reporting tree.
    // Without this check that reads as a false "rejected successfully".
    const rejectedCount = Number(result?.rejectedCount) || 0;
    const failedCount = Number(result?.failedCount) || 0;
    if (rejectedCount === 0) {
      throw new Error(
        ids.length > 1
          ? 'None of the selected requests could be rejected — they are no longer pending or are outside your review scope.'
          : 'This request could not be rejected — it is no longer pending or is outside your review scope.',
      );
    }
    if (failedCount > 0) {
      message.warning(
        `${rejectedCount} of ${rejectedCount + failedCount} edit requests rejected — the rest are no longer pending or are outside your review scope.`,
      );
    }
  },
};
